<template>
    <v-dialog v-model="dialogModel" scrollable class="w-33">
    <v-card>
        <v-card-title class="d-flex align-center pa-4 ga-2" >
            <v-icon :icon="mdiClipboardTextOutline" color="primary"/>
            <span>Appointment</span>
        </v-card-title>

        <v-divider />
        
        <v-card-text>
            <v-row>
                <v-col v-for="field in fields" :key="field.key" cols="12">
                    <v-card variant="outlined" class="border-thin">
                        <v-card-text v-if="field.type === 'date'">
                            <div class="mb-2">{{ field.key }}</div>
                            <div class="text-high-emphasis"> {{ new Date(field.value).toLocaleDateString("fr-FR") }} : {{ new Date(field.value).toLocaleTimeString("fr-FR") }}</div>
                        </v-card-text>
                        <v-card-text v-else-if="field.type === 'tree'">
                            <v-treeview :items="field.items" item-value="id" density="compact" indent-lines openOnClick fluid openAll :hide-actions="field.items[0].children.length == 0"/>
                        </v-card-text>
                        <v-card-text v-else>
                            <div class="mb-2">{{ field.key }}</div>
                            <div class="text-high-emphasis"> {{ field.value }}</div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
        
        <v-divider />
        
        <v-card-actions class="justify-end">
            <v-btn :prepend-icon="mdiDownloadOutline" @click="downloadJson">Download JSON</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script setup>
import { computed, inject, onBeforeMount, onMounted, ref } from 'vue';
import { mdiDownloadOutline, mdiClipboardTextOutline } from '@mdi/js';

const {data} = defineProps({ data: { type: Object, default: {} }});

const translate = inject('translate');

const dialogModel = ref(false);
const isoDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

// sort priority
// const typeOrder = { text: 0, date: 1, tree: 2 };

// Recursively converts an array / object into a v-treeview dataset
const fields = computed(() =>
    Object.entries(data ?? {}).map(([key, value]) => {
        if (value !== null && typeof value === 'object') {
            return { key, type: 'tree', items: [buildTree(value, key, key)] };
        }
        if (typeof value === 'string' && isoDate.test(value)) {
            return { key, type: 'date', value: value ?? 'null' };
        }
        return { key, type: 'text', value: value ?? 'null' };
    })
    //.sort((a, b) => typeOrder[a.type] - typeOrder[b.type])
);

onBeforeMount(() => { })

onMounted(() => { })

function open(){
    dialogModel.value = true;
}

function buildTree(value, key, path) {
    if (value !== null && typeof value === 'object') {
        return {
            id: path,
            title: key,
            children: Object.entries(value).map(([k, v]) => buildTree(v, k, `${path}.${k}`))
        };
    }
    return { id: path, title: `${key}: ${value ?? ''}` };
}

function downloadJson() {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `appointment_${data?.Uid ?? 'export'}.json`;
    link.click();
    URL.revokeObjectURL(url);
}

defineExpose({ open });

</script>
